import './actionButtonLoader.css';

export function ActionButtonSpinner() {
  return <span className="action-btn-loading__spinner" aria-hidden />;
}

export function getActionButtonLoadingClassName(loading, outline = false) {
  const classes = ['action-btn-loading'];
  if (outline) {
    classes.push('action-btn-loading--outline');
  }
  if (loading) {
    classes.push('is-loading');
  }
  return classes.join(' ');
}
